import { render, staticRenderFns } from "./SchedulerItemAvatar.vue?vue&type=template&id=110c3893"
import script from "./SchedulerItemAvatar.vue?vue&type=script&lang=ts"
export * from "./SchedulerItemAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110c3893')) {
      api.createRecord('110c3893', component.options)
    } else {
      api.reload('110c3893', component.options)
    }
    module.hot.accept("./SchedulerItemAvatar.vue?vue&type=template&id=110c3893", function () {
      api.rerender('110c3893', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduler/SchedulerItemAvatar.vue"
export default component.exports